"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.default = (0, react_intl_1.defineMessages)({
    workbenchNotebookNotebookCellMarkdownEdit: {
        id: 'workbench.notebook.notebook_cell.markdown.edit',
        defaultMessage: '*Click here to edit Markdown*',
    },
    workbenchRepositoryGitNotPulledPullConflictsModalHeadline: {
        id: 'workbench.repository.git_not_pulled.pull_conflicts_modal.headline',
        defaultMessage: 'Merge conflicts during pull',
    },
    workbenchRepositoryGitNotPulledPullConflictsModalLine1: {
        id: 'workbench.repository.git_not_pulled.pull_conflicts_modal.line1',
        defaultMessage: 'Merge conflicts occurred during the git pull.',
    },
    workbenchRepositoryGitNotPulledPullConflictsModalLine2: {
        id: 'workbench.repository.git_not_pulled.pull_conflicts_modal.line2',
        defaultMessage: 'Do you want to "force pull" and overwrite some of your local changes?',
    },
    workbenchRepositoryGitNotPulledPullConflictsModalLine3: {
        id: 'workbench.repository.git_not_pulled.pull_conflicts_modal.line3',
        defaultMessage: 'A backup copy of your local files will be created before they are overwritten.',
    },
    workbenchRepositoryGitNotPulledPullConflictsModalLine4: {
        id: 'workbench.repository.git_not_pulled.pull_conflicts_modal.line4',
        defaultMessage: 'The following files are affected:',
    },
    workbenchRepositoryGitNotPushedPushConflictsModalHeadline: {
        id: 'workbench.repository.git_not_pushed.push_conflicts_modal.headline',
        defaultMessage: 'Local branch is behind',
    },
    workbenchRepositoryGitNotPushedPushConflictsModalLine1: {
        id: 'workbench.repository.git_not_pushed.push_conflicts_modal.line1',
        defaultMessage: 'You are currently {commitsBehind} commit{pluralSuffix} behind the remote branch you want to push to.',
    },
    workbenchRepositoryGitNotPushedPushConflictsModalLine2: {
        id: 'workbench.repository.git_not_pushed.push_conflicts_modal.line2',
        defaultMessage: 'Please pull the remote commits first.',
    },
    workbenchSessionsEmpty: {
        id: 'workbench.sessions.empty',
        defaultMessage: 'There are no running Sessions',
    },
    workbenchSelectImage: {
        id: 'workbench.start.select_image',
        defaultMessage: 'Select the image / environment for your Workbench instance',
    },
});
//# sourceMappingURL=workbench.js.map